import React from 'react'

function PlaceDot({ colorCode }) {
    return (
        <svg className="MuiSvgIcon-root" viewBox="0 0 18 18" style={{ fill: 'none' }}>
            <circle cx="9" cy="9" r="8.5" stroke={colorCode} />
            <circle cx="9" cy="9" r="5" fill={colorCode} />
        </svg>
    )
}

export default PlaceDot
